import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "title", "description", "source"]
  static values = {
    whitepapers: Object
  }

  connect() {
    // 初始化模态窗口
  }

  open(event) {
    const paperKey = event.currentTarget.dataset.paperKey
    const whitepaper = this.whitepapersValue[paperKey]

    if (whitepaper) {
      this.titleTarget.textContent = whitepaper.title
      this.descriptionTarget.textContent = `请填写以下信息以获取"${whitepaper.title}"白皮书`
      this.sourceTarget.value = `whitepaper_${paperKey}`

      // 显示模态窗口
      this.modalTarget.classList.remove("hidden")
      // 添加背景色和透明度
      this.modalTarget.style.backgroundColor = "rgba(0, 0, 0, 0.7)"
      document.body.classList.add("overflow-hidden")
    }
  }

  close() {
    // 隐藏模态窗口
    this.modalTarget.classList.add("hidden")
    // 移除背景样式
    this.modalTarget.style.backgroundColor = ""
    document.body.classList.remove("overflow-hidden")
  }

  // 当点击模态窗口外部区域时关闭
  clickOutside(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }
}
